import { useRef } from 'react';
import { Tooltip } from 'react-tooltip';

import { useContentOverflow } from '../../../hooks';

import styles from './styles.module.scss';

interface LabelProps {
  value: string;
  index: number;
}

export const Label = ({ value, index }: LabelProps) => {
  const labelRef = useRef<HTMLInputElement>(null);
  const isOverflowing = useContentOverflow(labelRef);
  const id = `fieldLabelHint-${index}`;

  return (
    <div className={styles.tooltipContainer}>
      <div className={styles.label} id={id} ref={labelRef}>
        {value}
      </div>
      <Tooltip
        anchorSelect={`#${id}`}
        place="top"
        noArrow
        opacity={1}
        className={styles.tooltip}
        hidden={!isOverflowing}
      >
        {value}
      </Tooltip>
    </div>
  );
};
